<template>
  <div class="s-mid-video">
    <div class="s-mid-video__container">
      <div class="container">
        <div class="s-mid-video__player-container">
          <YouTubeVideo
            v-if="activeSlide.vid"
            ref="heroYouTubePlayer"
            v-model="soundState"
            :video-placeholder="activeSlide.thumb"
            :youtube-id="activeSlide.vid"
            :autoplay="1"
            :muted="true"
            :loop="true"
            overlay="b-youtube-video__gradiant"
            @video-percent="showVideoPercent"
            @on-player-state-change="videoStateChanged">
            <template #videoContent></template>
          </YouTubeVideo>
        </div>

        <div class="s-mid-video__elements">
          <div class="row">
            <div class="col-md-12 col-lg-10 offset-lg-1">
              <div class="s-mid-video__elements__ins">
                <div v-if="activeSlide.logo" class="s-mid-video__logo">
                  <img :src="activeSlide.logo" />
                </div>
                <a
                  v-if="activeSlide.ctaUrl"
                  :href="activeSlide.ctaUrl"
                  class="s-mid-video__cta">
                  <span>{{ activeSlide.ctaText }}</span>
                </a>

                <div class="s-mid-video__video-btns">
                  <template v-if="playingState !== 'INACTIVE'">
                    <div
                      :class="replayControlBtn"
                      @click="replayPauseTrailer"></div>
                    <div
                      :class="playingControlBtn"
                      @click="playPauseTrailer"></div>
                    <div
                      :class="soundControlBtn"
                      @click="changeTrailerSound"></div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="s-mid-video__texts">
          <div class="row">
            <div class="col-md-12 col-lg-10 offset-lg-1">
              <div class="s-mid-video__texts__ins">
                <div class="s-mid-video__title-elements">
                  <div class="s-mid-video__title">{{ activeSlide.title }}</div>
                </div>

                <div
                  class="s-mid-video__description"
                  v-html="activeSlide.desc"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import YouTubeVideo from '../components/YouTubeVideo.vue'
// import YouTubeVideoThumb from '../components/YouTubeVideoThumb.vue'
import { getData } from '../../lib/lib'
const { midVideo } = getData('middleVideoData')
// props

// emits

// reactive data
const playingState = ref('INACTIVE')
const soundState = ref(false)
const relayState = ref(false)
const heroYouTubePlayer = ref(null)
const videoPercent = ref(2)
const movieSlides = ref([])
const activeSlide = ref({})
const currentSlideIndex = ref(0)
// hooks
onMounted(() => {
  movieSlides.value = midVideo
  activeSlide.value = midVideo[currentSlideIndex.value]
})

// methods
const playingControlBtn = computed(() => {
  if (playingState.value === 'PLAYING') {
    return 's-hero-slider__pause-btn'
  } else if (playingState.value === 'PAUSED') {
    return 's-hero-slider__play-btn'
  }
  return ''
})

const soundControlBtn = computed(() => {
  return soundState.value
    ? 's-mid-video__sound-btn-on'
    : 's-mid-video__sound-btn-off'
})

const replayControlBtn = computed(() => {
  return relayState.value
    ? 's-mid-video__replaying-btn'
    : 's-mid-video__replaying-btn'
})

const playPauseTrailer = () => {
  if (playingState.value === 'PLAYING') {
    heroYouTubePlayer.value.pauseVideo()
  } else {
    heroYouTubePlayer.value.play()
  }
}

const replayPauseTrailer = () => {
  if (relayState.value) {
    heroYouTubePlayer.value.replay()
    relayState.value = false
  } else {
    heroYouTubePlayer.value.replay()
    relayState.value = true
  }
}

const showVideoPercent = (progress) => {
  videoPercent.value = progress
}

const videoStateChanged = async (ev, player, descr) => {
  if (descr) {
    playingState.value = descr.label
  }
}

const changeTrailerSound = () => {
  if (soundState.value) {
    heroYouTubePlayer.value.mute()
    soundState.value = false
  } else {
    heroYouTubePlayer.value.unMute()
    soundState.value = true
  }
}
</script>
